// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'object-case';

export const Component = () => (
  <>
    <path d='M9.1 2c.527 0 .814.239.91.67l.765 2.3H23c.239 0 .559.096.75.287.191.191.25.432.25.67v8.823l-1-1.5V5.927H10.775c-.43 0-.766-.24-.91-.671L9.1 3.006H.957V22H7.75L7 23H1c-.24 0-.608-.009-.8-.2-.191-.192-.2-.56-.2-.8V3.006c0-.24.096-.48.287-.719A.947.947 0 0 1 .958 2z' />
    <path d='M25 18.523 19.853 25H8l4.191-6.478L8 12h11.852zm-11.62.001L9.839 24h9.532l4.354-5.48L19.368 13H9.831z' />
  </>
);

export const viewBox = '0 0 25 25';
